import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import { FaEdit, FaPlus } from "react-icons/fa";
import axios from "axios";

function ModalPDF({ value = [], label = "", onSubmit }) {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState([]); // This will hold PDFs data

  const toggleModal = () => setOpen(!open);

  // Handle changes in text fields (description, file)
  const handleChange = (index, field, value) => {
    const newContent = [...content];
    newContent[index][field] = value;
    setContent(newContent);
  };

  // Add a new field for a new PDF entry
  const addNewField = () => {
    setContent([
      ...content,
      { description: "", file: null, fileName: "" }
    ]);
  };

  // Handle form submission (add or update PDFs)
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const uploadPromises = content.map(async ({ _id, description, file, fileName }) => {
        if (!description || !file) return;
        const formData = new FormData();
        formData.append("description", description); // Include the description
        if (file) {
          formData.append("pdf", file); // Append the PDF file
        }

        if (_id) {
          // Update existing PDF entry
          await axios.put(`/api/pdf/${_id}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        } else {
          // Create a new PDF entry
          await axios.post("/api/pdf", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        }
      });

      // Wait for all promises to resolve
      await Promise.all(uploadPromises);

      // Re-fetch the updated PDFs list so new _id values are available
      const response = await axios.get("/api/pdfs");
      const updated = response.data.map((item) => ({
        _id: item._id || item.id,
        description: item.description || "",
        fileName: item.name || "No file chosen",
        file: null
      }));
      setContent(updated);

      alert("PDF data saved successfully!");
      toggleModal(); // Close the modal after submission
      onSubmit(updated); // Update parent component with new content
    } catch (err) {
      console.error("Error saving PDF:", err);
      alert("Failed to save PDF.");
    }
  };

  // Handle PDF deletion
  const handleDelete = async (id, index) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this PDF?");
    if (!confirmDelete) return;

    try {
      await axios.delete(`/api/pdf/${id}`);
      const updated = content.filter((_, i) => i !== index);
      setContent(updated);
      onSubmit(updated); // Update parent component after deletion
    } catch (err) {
      console.error("Error deleting PDF:", err);
      alert("Failed to delete PDF.");
    }
  };

  // Fetch existing PDFs from backend on component mount
  useEffect(() => {
    const fetchPDFs = async () => {
      try {
        const response = await axios.get("/api/pdfs");
        const normalized = response.data.map((item) => ({
          _id: item._id || item.id,
          description: item.description || "",
          fileName: item.name || "No file chosen",
          file: null
        }));
        setContent(normalized);
      } catch (err) {
        console.error("Error fetching PDFs:", err);
      }
    };

    fetchPDFs();
  }, []);

  return (
    <div className="modalDiv">
      <FaEdit className="icon-button" onClick={toggleModal} />

      <Popup
        className="editModal"
        open={open}
        closeOnDocumentClick={false}
        contentStyle={{
          overflowY: 'auto',
          maxHeight: '80vh',
          padding: '20px',
          width: '500px',
        }}
      >
        <a className="close" onClick={toggleModal}>
          &times;
        </a>
        <h3>Manage PDFs</h3>

        <form onSubmit={handleSubmit}>
          {content.map((item, index) => (
            <div key={index} className="upload-row" style={{ marginBottom: '15px' }}>
              <input
                type="text"
                placeholder="Description"
                value={item.description}
                onChange={(e) => handleChange(index, "description", e.target.value)}
                required
              />

              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                <label
                  htmlFor={`file-upload-${index}`}
                  style={{
                    backgroundColor: '#f0f0f0',
                    padding: '6px 12px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    border: '1px solid #ccc',
                  }}
                >
                  Choose File
                </label>

                <span style={{ fontSize: '12px', color: '#555' }}>
                  {item.fileName || 'No file chosen'}
                </span>

                <input
                  id={`file-upload-${index}`}
                  type="file"
                  accept=".pdf"
                  style={{ display: 'none' }}
                  onChange={(e) => {
                    handleChange(index, "file", e.target.files[0]);
                    handleChange(index, "fileName", e.target.files[0]?.name || item.fileName);
                  }}
                />

                {/* Show delete button only if the PDF has an ID */}
                {item._id && (
                  <button
                    type="button"
                    onClick={() => handleDelete(item._id, index)}
                    style={{
                      backgroundColor: 'red',
                      color: 'white',
                      border: 'none',
                      padding: '5px 10px',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    Delete
                  </button>
                )}
              </div>
            </div>
          ))}

          <FaPlus onClick={addNewField} className="icon-button" style={{ cursor: 'pointer', marginTop: '10px' }} />
          <button type="submit" style={{ marginTop: '15px' }}>Submit</button>
        </form>
      </Popup>
    </div>
  );
}

export default ModalPDF;
